export default "__VITE_ASSET__1d1b9bdd__"